import { Box, Checkbox, Typography } from "@mui/material";
import useColors from "../../../../../../../../api/hooks/useColors";
import SvgToIcon from "../../../../../../../../icons/SvgToIcon";
import { ReactComponent as UnCheckedIcon } from "../../../../../../../../scenes/stack/environment/icons/checkbox-off.svg";
import { ReactComponent as CheckedIcon } from "../../../../../../../../scenes/stack/environment/icons/checkbox-on.svg";
import { ReactComponent as SeverityOrangeIcon } from "../../../../../../../../scenes/stack/environment/icons/severity_icons/severity-icons-medium-24.svg";

export default function AcceptSection({
  accepted,
  setAccepted,
  loadingConfirmation,
}) {
  const colors = useColors();

  return (
    <Box display="flex" flexDirection="column" gap={1}>
      <Box
        border={"1px solid " + colors.warning_orange_32}
        borderRadius="8px"
        padding="8px"
        sx={{
          backgroundColor: colors.warning_orange_2,
        }}
      >
        <Box
          display="flex"
          flexDirection="column"
          gap={0.5}
          padding="4px 0 4px 4px"
        >
          <Box display="flex" gap={1} alignItems="center">
            <Box
              width="24px"
              height="24px"
              borderRadius="8px"
              display="flex"
              alignItems="center"
              justifyContent="center"
              sx={{
                backgroundColor: colors.warning_orange_8,
                boxShadow: "0px 0px 3px -1px " + colors.warning_orange_70,
              }}
            >
              <SvgToIcon IconLogo={SeverityOrangeIcon} width="17px" />
            </Box>
            <Typography variant="subtitle2" color={colors.text_primary}>
              Before You Proceed
            </Typography>
          </Box>
          <Box padding="4px 8px 4px 4px">
            <Typography variant="body2" color={colors.text_primary}>
              Before proceeding, review the summary carefully. By continuing,
              you acknowledge the potential impact and take
              <br />
              responsibility for applying this change.
            </Typography>
          </Box>
        </Box>
      </Box>
      <Box display="flex" alignItems="center">
        <Checkbox
          icon={<UnCheckedIcon />}
          checkedIcon={<CheckedIcon />}
          disableRipple
          checked={accepted}
          onChange={() => setAccepted(!accepted)}
          disabled={loadingConfirmation}
        />
        <Typography variant="body2" color={colors.text_primary}>
          I have reviewed the summary and accept responsibility for this action.
        </Typography>
      </Box>
    </Box>
  );
}
